/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerFindAllTasksQueryResponse, FilesControllerFindAllTasksPathParams, FilesControllerFindAllTasksQueryParams, FilesControllerFindAllTasks401, FilesControllerFindAllTasks403, FilesControllerFindAllTasks404 } from "../../models/filesController/FilesControllerFindAllTasks";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { filesControllerFindAllTasks } from "../../clients/filesService/filesControllerFindAllTasks";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const filesControllerFindAllTasksQueryKey = (id: FilesControllerFindAllTasksPathParams["id"], params: FilesControllerFindAllTasksQueryParams = {}) => [{
  url: '/api/v1/files/:id/tasks',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type FilesControllerFindAllTasksQueryKey = ReturnType<typeof filesControllerFindAllTasksQueryKey>;
export function filesControllerFindAllTasksQueryOptions(id: FilesControllerFindAllTasksPathParams["id"], params?: FilesControllerFindAllTasksQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = filesControllerFindAllTasksQueryKey(id, params);
  return queryOptions<FilesControllerFindAllTasksQueryResponse, ResponseErrorConfig<FilesControllerFindAllTasks401 | FilesControllerFindAllTasks403 | FilesControllerFindAllTasks404>, FilesControllerFindAllTasksQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return filesControllerFindAllTasks(id, params, config);
    }
  });
}

/**
 * @summary List tasks under this file (file scope + descendants)
 * {@link /api/v1/files/:id/tasks}
 */
export function useFilesControllerFindAllTasks<TData = FilesControllerFindAllTasksQueryResponse, TQueryData = FilesControllerFindAllTasksQueryResponse, TQueryKey extends QueryKey = FilesControllerFindAllTasksQueryKey>(id: FilesControllerFindAllTasksPathParams["id"], params?: FilesControllerFindAllTasksQueryParams, options: {
  query?: Partial<QueryObserverOptions<FilesControllerFindAllTasksQueryResponse, ResponseErrorConfig<FilesControllerFindAllTasks401 | FilesControllerFindAllTasks403 | FilesControllerFindAllTasks404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? filesControllerFindAllTasksQueryKey(id, params);
  const query = useQuery({
    ...filesControllerFindAllTasksQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FilesControllerFindAllTasks401 | FilesControllerFindAllTasks403 | FilesControllerFindAllTasks404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}